import { render, staticRenderFns } from "./COOKIES.vue?vue&type=template&id=0e197e94"
import script from "./COOKIES.vue?vue&type=script&lang=js"
export * from "./COOKIES.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports